export default {
  baseAccessUrl: process.env.NEXT_PUBLIC_ACCESS_URL,
  baseApiUrl: process.env.NEXT_PUBLIC_API_URL,
  baseApiKey: process.env.NEXT_PUBLIC_API_KEY,
}
